// extracted by mini-css-extract-plugin
export var icon = "_5x-1";
export var subtext = "_5x-0";